/*================================
	裁切圖片的Modal
	Author : Tim
================================*/

window.InifECApp.directive('imageCropModal', [function () {
	return {
		restrict: "E",
		templateUrl: "partials/modal/image_crop_modal.html",
		link: function(scope, element, attrs) {

		},
		controller : ['$scope', function ($scope) {

		}]
	};
}])